module.exports = __webpack_public_path__ + "static/media/insuranceLogo-min.2ed44c50.png";